<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DaV4Vg/tc-custom/9781429988285.jpg?1737768750775" alt="This image is the cover for the book Stealing from the Dead"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stealing from the Dead
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>Stealing from the Dead, </i>detective Greta Strasser uncovers a brutal plot to steal millions from Holocaust survivors and fuel a vast terrorist conspiracy.<br/><br/>Between 1933 and 1945, thousands of Jewish people deposited their money in Swiss bank accounts, hoping that they or their family might survive the Holocaust. However, when the survivors returned to reclaim their money, the banks claimed that the accounts never existed. <br/><br/>Now, decades later, NYPD detective Greta Strasser, investigating the death of an elderly Jewish woman, stumbles onto a conspiracy that stretches from New York and Los Angeles to Germany, from Switzerland to the Middle East. Greta, recruited by a special task force, follows a trail of ruthless murders. <br/><br/>The conspirators have hired an assassin to kill the people on the Claims Resolution Tribunal list. Greta, hell-bent on stopping the senseless deaths and enormous theft of funds, goes undercover to prevent the next murder, even though it means impersonating the assassin she hunts. <br/><br/>With all the tension and excitement that fueled <i>The Lost Van Gogh</i>, A. J. Zerries has written another novel of enormous excitement and constantly building suspense.<br/><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A. J. Zerries
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c33b4e64